import { render, staticRenderFns } from "./SysHelpIndex.vue?vue&type=template&id=54133f64&scoped=true&"
import script from "./SysHelpIndex.vue?vue&type=script&lang=js&"
export * from "./SysHelpIndex.vue?vue&type=script&lang=js&"
import style0 from "./SysHelpIndex.vue?vue&type=style&index=0&id=54133f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54133f64",
  null
  
)

export default component.exports